import template from "./locations.html";
import controller from "./locations.controller";
import "./locations.scss";

let branchManagementLocationsComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementLocationsComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/locations/locations.component.js